import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ImPaginationController', ImPaginationController);

    function ImPaginationController($http, $scope) {
        var vm = this;

        init();

        function init() {
            vm.changePage = changePage;
            vm.changePageToNextOrPrev = changePageToNextOrPrev;
            vm.changeHowManyElements = changeHowManyElements;
            getCurrentObject();
        }

        function changePage() {
            if (vm.params.page > vm.selectedObject.max_pages) {
                vm.params.page = vm.selectedObject.max_pages;
            } else if (vm.params.page < 1) {
                vm.params.page = 1;
            }
            getItems(vm.params);
        }

        function changePageToNextOrPrev(prevOrNext) {
            if (prevOrNext === 'prev') {
                vm.params.page--;
            } else if (prevOrNext === 'next') {
                vm.params.page++;
            }
            getItems(vm.params);
        }

        function getItems(params) {
            if (vm.apiFunction) {
                if (vm.clientId) {
                    vm.apiFunction(vm.clientId, params).then(function (
                        response
                    ) {
                        vm.selectedObject = response.data;
                        document.documentElement.scrollTop = 0;
                    });
                } else {
                    vm.apiFunction(params).then(function (response) {
                        vm.selectedObject = response.data;
                        document.documentElement.scrollTop = 0;
                    });
                }
            } else if (vm.apiString) {
                $http
                    .get(vm.apiString, { params: params })
                    .then(function (response) {
                        vm.selectedObject = response.data;
                        document.documentElement.scrollTop = 0;
                    });
            }
        }

        function changeHowManyElements(number) {
            vm.params.page_size = number;
            vm.params.page = 1;
            vm.perPage = number;
            getItems(vm.params);
        }

        function getCurrentObject() {
            $scope.$watchGroup(
                [
                    function () {
                        return vm.selectedObject;
                    },
                    function () {
                        return vm.params;
                    },
                ],
                function () {
                    if (vm.selectedObject && vm.params) {
                        vm.params.page = vm.params.page || 1;
                        vm.params.page_size = vm.params.page_size || 10;
                        vm.perPage = vm.params.page_size;
                        vm.selectedObject.max_pages = Math.ceil(
                            vm.selectedObject.count / vm.params.page_size
                        );
                    }
                }
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/pagination/pagination.controller.ts